import { AlternativeReadModel } from "@Alternatives/Alternatives/Domain/readmodels";

export class AlternativeRelationshipsDialogViewModel
{
    workspaceId: number;
    tchProjectId: number;

    alternativeId: string | null = null;
    alternativeName: string | null = null;
    alternativeStatusId: number | null = null;
    alternativeStatusName: string | null = null;
    dependents: AlternativeReadModel[] = [];
    foundations: AlternativeReadModel[] = [];

    allAlternatives: AlternativeReadModel[] | null = null; 
    alternativeLabel: string | null = null;
    alternativesLabel: string | null = null;

    opened: boolean = false;

    constructor(workspaceId: number, tchProjectId: number)
    {
        this.workspaceId = workspaceId;
        this.tchProjectId = tchProjectId;
    }

    show(alternativeId: string, alternativeName: string, alternativeStatusId: number, alternativeStatusName: string, dependents: AlternativeReadModel[], foundations: AlternativeReadModel[], alternativeLabel: string, alternativesLabel: string)
    {
        this.alternativeId = alternativeId;
        this.alternativeName = alternativeName;
        this.alternativeStatusId = alternativeStatusId; 
        this.alternativeStatusName = alternativeStatusName;
        this.dependents = dependents;
        this.foundations = foundations;

        this.alternativeLabel = alternativeLabel;
        this.alternativesLabel = alternativesLabel;

        this.opened = true;
    }

    close()
    {
        this.opened = false;
    }

    setAlternatives(alternatives: AlternativeReadModel[])
    {
        this.allAlternatives = alternatives;
    }

    removeDependent(depId: string)
    {
        this.dependents = this.dependents.filter(a => a.Id !== depId);
    }

    removeFoundation(fId: string)
    {
        this.foundations = this.foundations.filter(a => a.Id !== fId);
    }

    addDependent(depId: string)
    {
        const d = this.allAlternatives.find(a => a.Id === depId);
        this.dependents.push(d);
    }

    addFoundation(fId: string)
    {
        const f = this.allAlternatives.find(a => a.Id === fId);
        this.foundations.push(f);
    }
}